
const NotFound = () => {
  return (
    <div className='flex items-center justify-center h-screen bg-gray-100'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold text-gray-800'>Under Maintenance</h1>
        <p className='mt-2 text-gray-600'>Comming Up Soon...</p>
      </div>
    </div>
  );
};

export default NotFound